/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetRouteImport } from './routes/reset'
import { Route as LoginRouteImport } from './routes/login'
import { Route as HistoryRouteImport } from './routes/history'
import { Route as LevelRouteImport } from './routes/$level'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LevelsLevelRouteImport } from './routes/levels.$level'
import { Route as HistoryAttemptsAttemptIdRouteImport } from './routes/history.attempts.$attemptId'
import { Route as LevelsLevelExamsExamSlugRouteImport } from './routes/levels.$level.exams.$examSlug'
import { Route as CoursesCourseSlugSectionsSectionSlugRouteImport } from './routes/courses.$courseSlug.sections.$sectionSlug'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetRoute = ResetRouteImport.update({
  id: '/reset',
  path: '/reset',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryRoute = HistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => rootRouteImport,
} as any)
const LevelRoute = LevelRouteImport.update({
  id: '/$level',
  path: '/$level',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LevelsLevelRoute = LevelsLevelRouteImport.update({
  id: '/levels/$level',
  path: '/levels/$level',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryAttemptsAttemptIdRoute =
  HistoryAttemptsAttemptIdRouteImport.update({
    id: '/attempts/$attemptId',
    path: '/attempts/$attemptId',
    getParentRoute: () => HistoryRoute,
  } as any)
const LevelsLevelExamsExamSlugRoute =
  LevelsLevelExamsExamSlugRouteImport.update({
    id: '/exams/$examSlug',
    path: '/exams/$examSlug',
    getParentRoute: () => LevelsLevelRoute,
  } as any)
const CoursesCourseSlugSectionsSectionSlugRoute =
  CoursesCourseSlugSectionsSectionSlugRouteImport.update({
    id: '/courses/$courseSlug/sections/$sectionSlug',
    path: '/courses/$courseSlug/sections/$sectionSlug',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$level': typeof LevelRoute
  '/history': typeof HistoryRouteWithChildren
  '/login': typeof LoginRoute
  '/reset': typeof ResetRoute
  '/signup': typeof SignupRoute
  '/levels/$level': typeof LevelsLevelRouteWithChildren
  '/history/attempts/$attemptId': typeof HistoryAttemptsAttemptIdRoute
  '/courses/$courseSlug/sections/$sectionSlug': typeof CoursesCourseSlugSectionsSectionSlugRoute
  '/levels/$level/exams/$examSlug': typeof LevelsLevelExamsExamSlugRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$level': typeof LevelRoute
  '/history': typeof HistoryRouteWithChildren
  '/login': typeof LoginRoute
  '/reset': typeof ResetRoute
  '/signup': typeof SignupRoute
  '/levels/$level': typeof LevelsLevelRouteWithChildren
  '/history/attempts/$attemptId': typeof HistoryAttemptsAttemptIdRoute
  '/courses/$courseSlug/sections/$sectionSlug': typeof CoursesCourseSlugSectionsSectionSlugRoute
  '/levels/$level/exams/$examSlug': typeof LevelsLevelExamsExamSlugRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$level': typeof LevelRoute
  '/history': typeof HistoryRouteWithChildren
  '/login': typeof LoginRoute
  '/reset': typeof ResetRoute
  '/signup': typeof SignupRoute
  '/levels/$level': typeof LevelsLevelRouteWithChildren
  '/history/attempts/$attemptId': typeof HistoryAttemptsAttemptIdRoute
  '/courses/$courseSlug/sections/$sectionSlug': typeof CoursesCourseSlugSectionsSectionSlugRoute
  '/levels/$level/exams/$examSlug': typeof LevelsLevelExamsExamSlugRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$level'
    | '/history'
    | '/login'
    | '/reset'
    | '/signup'
    | '/levels/$level'
    | '/history/attempts/$attemptId'
    | '/courses/$courseSlug/sections/$sectionSlug'
    | '/levels/$level/exams/$examSlug'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$level'
    | '/history'
    | '/login'
    | '/reset'
    | '/signup'
    | '/levels/$level'
    | '/history/attempts/$attemptId'
    | '/courses/$courseSlug/sections/$sectionSlug'
    | '/levels/$level/exams/$examSlug'
  id:
    | '__root__'
    | '/'
    | '/$level'
    | '/history'
    | '/login'
    | '/reset'
    | '/signup'
    | '/levels/$level'
    | '/history/attempts/$attemptId'
    | '/courses/$courseSlug/sections/$sectionSlug'
    | '/levels/$level/exams/$examSlug'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LevelRoute: typeof LevelRoute
  HistoryRoute: typeof HistoryRouteWithChildren
  LoginRoute: typeof LoginRoute
  ResetRoute: typeof ResetRoute
  SignupRoute: typeof SignupRoute
  LevelsLevelRoute: typeof LevelsLevelRouteWithChildren
  CoursesCourseSlugSectionsSectionSlugRoute: typeof CoursesCourseSlugSectionsSectionSlugRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset': {
      id: '/reset'
      path: '/reset'
      fullPath: '/reset'
      preLoaderRoute: typeof ResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history': {
      id: '/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof HistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$level': {
      id: '/$level'
      path: '/$level'
      fullPath: '/$level'
      preLoaderRoute: typeof LevelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/levels/$level': {
      id: '/levels/$level'
      path: '/levels/$level'
      fullPath: '/levels/$level'
      preLoaderRoute: typeof LevelsLevelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history/attempts/$attemptId': {
      id: '/history/attempts/$attemptId'
      path: '/attempts/$attemptId'
      fullPath: '/history/attempts/$attemptId'
      preLoaderRoute: typeof HistoryAttemptsAttemptIdRouteImport
      parentRoute: typeof HistoryRoute
    }
    '/levels/$level/exams/$examSlug': {
      id: '/levels/$level/exams/$examSlug'
      path: '/exams/$examSlug'
      fullPath: '/levels/$level/exams/$examSlug'
      preLoaderRoute: typeof LevelsLevelExamsExamSlugRouteImport
      parentRoute: typeof LevelsLevelRoute
    }
    '/courses/$courseSlug/sections/$sectionSlug': {
      id: '/courses/$courseSlug/sections/$sectionSlug'
      path: '/courses/$courseSlug/sections/$sectionSlug'
      fullPath: '/courses/$courseSlug/sections/$sectionSlug'
      preLoaderRoute: typeof CoursesCourseSlugSectionsSectionSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface HistoryRouteChildren {
  HistoryAttemptsAttemptIdRoute: typeof HistoryAttemptsAttemptIdRoute
}

const HistoryRouteChildren: HistoryRouteChildren = {
  HistoryAttemptsAttemptIdRoute: HistoryAttemptsAttemptIdRoute,
}

const HistoryRouteWithChildren =
  HistoryRoute._addFileChildren(HistoryRouteChildren)

interface LevelsLevelRouteChildren {
  LevelsLevelExamsExamSlugRoute: typeof LevelsLevelExamsExamSlugRoute
}

const LevelsLevelRouteChildren: LevelsLevelRouteChildren = {
  LevelsLevelExamsExamSlugRoute: LevelsLevelExamsExamSlugRoute,
}

const LevelsLevelRouteWithChildren = LevelsLevelRoute._addFileChildren(
  LevelsLevelRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LevelRoute: LevelRoute,
  HistoryRoute: HistoryRouteWithChildren,
  LoginRoute: LoginRoute,
  ResetRoute: ResetRoute,
  SignupRoute: SignupRoute,
  LevelsLevelRoute: LevelsLevelRouteWithChildren,
  CoursesCourseSlugSectionsSectionSlugRoute:
    CoursesCourseSlugSectionsSectionSlugRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
